import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormType } from '../../../enums/form.enum';

@Component({
  selector: 'siu-modal-form-container',
  templateUrl: './modal-form-container.component.html',
  styleUrls: [ './modal-form-container.component.scss' ]
})
export class ModalFormContainerComponent implements OnInit {

  @Input() title: string;
  @Input() loading: boolean = false;
  @Input() formGroup: FormGroup;
  @Input() msgErrors: any[];
  @Output('on-dismiss') onDismissEvent: EventEmitter<any> = new EventEmitter();
  @Output('on-submit') onSubmitEvent: EventEmitter<any> = new EventEmitter();
  @Input() formType: FormType;
  @Input() modoConsulta: boolean = false;
  @Input("ok-label") okLabel: string = "Guardar";
  @Input("ok-icon") okIcon: string = "save";
  @Input() ocultarSubmit: boolean = false;
  @Input() ocultarCancel: boolean = false;
  
  FormType = FormType;


  constructor() { }

  ngOnInit() {
  }

  HandleDismiss = () => {
    this.onDismissEvent.emit();
  }

  HandleSubmit = () => {
    this.onSubmitEvent.emit();
  }

}
